
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  clientName = prop<string>({ default: "", type: String });
  estimateAdditionalKoli = prop<string>({ default: "", type: String });
  estimateWeight = prop<string>({ default: "", type: String });
  serviceCodes = prop<string[]>({
    default: () => [],
    type: Array as PropType<string[]>
  });
  additionalKoliError = prop<string>({ default: "", type: String });
  weightError = prop<string>({ default: "", type: String });
  loading = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  emits: [
    "update:estimateAdditionalKoli",
    "update:estimateWeight",
    "update:serviceCodes"
  ]
})
export default class ShipmentInfoSection extends Vue.with(Props) {
  get additionalKoliValue(): string {
    return this.estimateAdditionalKoli;
  }

  set additionalKoliValue(value: string) {
    this.$emit("update:estimateAdditionalKoli", value);
  }

  get weightValue(): string {
    return this.estimateWeight;
  }

  set weightValue(value: string) {
    this.$emit("update:estimateWeight", value);
  }

  get serviceCodeValues(): string[] {
    return this.serviceCodes;
  }

  set serviceCodeValues(value: string[]) {
    this.$emit("update:serviceCodes", value);
  }
}
